import { useGoogleLogin } from "@react-oauth/google";
import { useOpenBaas } from "../Context/SdkBaasOpen";
import useIsLogin from "../hooks/useIsLogin";

function useGoogle() {
  const { uri, setAccessToken, setRefreshToken } = useOpenBaas();
  const { setIsLogin } = useIsLogin();
  const googleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const res = await fetch(`${uri}/v1/auth/google`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${codeResponse.access_token}`,
        },
        body: JSON.stringify({ created: new Date() }),
      });
      const { status, accessToken, refreshToken } = await res.json();
      if (status) {
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        setIsLogin(true);
      }
    },
    flow: "implicit",
  });
  return { googleLogin };
}

export default useGoogle;
